import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { JOB_STATUS_CONFIG } from "./JobStatusBadge"

// Display order, left → right: most complete first, so the bar reads as a fill
// that grows from the left as jobs finish. `countKey` matches the camelCased
// wire payload; `status` keys into JOB_STATUS_CONFIG for the color and label.
export const JOB_STATUS_DISPLAY_ORDER = [
  { countKey: "completed", status: "completed" },
  { countKey: "inProgress", status: "in_progress" },
  { countKey: "onHold", status: "on_hold" },
  { countKey: "notStarted", status: "not_started" },
]

const JobProgressBar = ({ counts, total }) => {
  if (total <= 0) return null

  return (
    <div className="flex h-2 overflow-hidden rounded-full bg-gray-100">
      {JOB_STATUS_DISPLAY_ORDER.map(({ countKey, status }) => {
        const count = counts[countKey] || 0
        if (count === 0) return null

        return (
          <div
            key={countKey}
            className={classNames("h-full", JOB_STATUS_CONFIG[status].dotColor)}
            style={{ width: `${(count / total) * 100}%` }}
          />
        )
      })}
    </div>
  )
}

JobProgressBar.propTypes = {
  counts: PropTypes.objectOf(PropTypes.number).isRequired,
  total: PropTypes.number.isRequired,
}

export default JobProgressBar
